import React, { createContext, useContext } from 'react';

const ShopOrgContext = createContext(null);

export const useShopOrg = () => {
  const context = useContext(ShopOrgContext);
  if (!context) {
    throw new Error('useShopOrg must be used within a ShopOrgProvider');
  }
  return context;
};

export const ShopOrgProvider = ({ org, children }) => (
  <ShopOrgContext.Provider value={org}>{children}</ShopOrgContext.Provider>
);

export default ShopOrgContext;
